import { useEffect, useRef } from 'react';

export function useKeyboardInput(
  setRudderInput: (input: number) => void,
  togglePause: () => void
) {
  const keysPressedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.repeat) return;

      keysPressedRef.current.add(e.key.toLowerCase());

      if (e.key === 'Escape' || e.key.toLowerCase() === 'p') {
        togglePause();
        return;
      }

      if (e.key === 'ArrowLeft' || e.key.toLowerCase() === 'h') {
        setRudderInput(-1);
        e.preventDefault();
      } else if (e.key === 'ArrowRight' || e.key.toLowerCase() === 'l') {
        setRudderInput(1);
        e.preventDefault();
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      keysPressedRef.current.delete(e.key.toLowerCase());

      const keys = keysPressedRef.current;
      const leftPressed = keys.has('arrowleft') || keys.has('h');
      const rightPressed = keys.has('arrowright') || keys.has('l');

      if (
        (e.key === 'ArrowLeft' || e.key.toLowerCase() === 'h') &&
        !rightPressed
      ) {
        setRudderInput(0);
      }
      if (
        (e.key === 'ArrowRight' || e.key.toLowerCase() === 'l') &&
        !leftPressed
      ) {
        setRudderInput(0);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [setRudderInput, togglePause]);
}
